import { render, staticRenderFns } from "./EntHarmonizationOntology.vue?vue&type=template&id=c1c12450&scoped=true&"
import script from "./EntHarmonizationOntology.vue?vue&type=script&lang=ts&"
export * from "./EntHarmonizationOntology.vue?vue&type=script&lang=ts&"
import style0 from "./EntHarmonizationOntology.vue?vue&type=style&index=0&id=c1c12450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c12450",
  null
  
)

export default component.exports